export default function () {
  console.log('ERRRORORORORORORORORORORORO');
}
